<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{snackbar_message}}</span>
        </v-snackbar>
        <v-card class="neu-glow elevation-8 pb-5">
          <v-card-title primary-title>
            <div class="text-h5 mr-6">Segreteria Telefonica</div>
            <!--
            <v-tooltip top>
               <template v-slot:activator="{ on, attrs }">
               <v-btn v-if="VMOptions" v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  :disabled="items_hash==JSON.stringify(items)" @click.stop="enableVoiceMail()">
                  <v-icon  :color="VMOptions.find(o=o.optionId=='pbxEnabled').value=='1'?'error':''">{{VMOptions.find('pbxEnabled').value=='1'?'mdi-lightbulb-on-outline':'mdi-lightbulb-outline'}}</v-icon>
                  {{VMOptions.find('pbxEnabled')}}
               </v-btn>
               </template>
               <span>Abilita Segreteria</span>
            </v-tooltip>
            -->
            <v-spacer></v-spacer>
            <v-div>
               <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  :disabled="items_hash==JSON.stringify(items)" @click.stop="saveItems()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="getData('refresh')">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip> 
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="toggleTreeview">
                  <v-icon>{{expanded ? "mdi-arrow-collapse-all" : "mdi-arrow-expand-all"}}</v-icon>
                </v-btn>
              </template>
              <span>{{expanded?'Chiudi':'Esplodi'}}</span>
            </v-tooltip>                          
            </v-div>           
          </v-card-title>
            <v-row v-if="!VMOptions">
                <v-col class="text-center">
                  <v-progress-linear
                    color="info"
                    height="10"
                    indeterminate
                    striped
                  ></v-progress-linear>
                </v-col>
            </v-row>
            <div v-else class="mx-4">
               <v-card class="pt-4 pb-1 neu-glow">
                  <v-row class="pt-1 ml-1">
                     <v-col cols="4">
                        <v-card class="ma-4 neu-glow">
                           <v-card-title>
                              <v-row class="pl-3 pt-2 pb-4">
                                 <v-col class="pa-0 text-h5">
                                    Segreteria
                                 </v-col>
                                 <v-col class="pa-0 d-flex justify-center align-center">
                                    <v-switch
                                       color="info"
                                       v-model="pbxEnabled"
                                       inset
                                       @click.native.stop="voiceMailChangeStatus()"
                                       :label="pbxEnabled?'Attiva':'Non Attiva'"
                                       hide-details
                                       class="mt-0 pt-0"
                                    ></v-switch> 
                                 </v-col>                                    
                              </v-row>
                           </v-card-title>
                           <template v-if="VMOptions">
                              <template v-for="(i,ii) in VMOptions.filter(o=>o.optionId!=='pbxEnabled')">
                                 <div :key="ii" class="mb-3 px-3">
                                    <template v-if="i.dataType=='nvarchar'">
                                       <v-text-field 
                                          counter
                                          :label="i.description"
                                          :name="i.optionId"
                                          outlined
                                          :reverse="i.dataType!='nvarchar'"
                                          v-model="VMOptions[ii+1].value"
                                          persistent-placeholder
                                          hide-details
                                          @input.native="save"
                                          :readonly="!i.editableByUser"
                                       >
                                       </v-text-field>
                                    </template>
                                    <template v-else-if="i.dataType=='textarea'">
                                       <v-textarea 
                                          auto-grow
                                          rows="2"
                                          counter
                                          :label="i.description"
                                          :name="i.optionId"
                                          outlined
                                          v-model="VMOptions[ii+1].value"
                                          persistent-placeholder
                                          hide-details
                                          @input.native="save"
                                          :readonly="!i.editableByUser"
                                       >
                                       </v-textarea>
                                    </template>
                                    <template v-else-if="i.dataType=='int'||i.dataType=='time'||i.dataType=='date'">
                                       <v-text-field 
                                          counter
                                          :label="i.description"
                                          :name="i.optionId"
                                          outlined
                                          :reverse="i.dataType!='nvarchar'"
                                          v-model="VMOptions[ii+1].value"
                                          persistent-placeholder
                                          hide-details
                                          @input.native="save"
                                          :readonly="!i.editableByUser"
                                       >
                                       </v-text-field>
                                    </template>
                                    <template v-else-if="i.dataType=='bit'">
                                       <v-row class="pl-3 pt-2 pb-4">
                                          <v-col class="pa-0">
                                             {{i.description}}
                                          </v-col>
                                          <v-col class="pa-0 d-flex justify-center">
                                             <v-switch
                                                color="info"
                                                v-model="VMOptions[ii+1].value"
                                                inset
                                                @change="save2($event, i.optionId)"
                                                :label="i.value?'Attiva':'Non Attiva'"
                                                hide-details
                                                :readonly="!i.editableByUser"
                                                class="mt-0 pt-0"
                                             ></v-switch> 
                                          </v-col>                                    
                                       </v-row>                     
                                    </template>                                 
                                 </div>
                              </template>
                           </template>
                        </v-card>
                        <!--
                        <v-text-field
                           outlined
                           label="Numero Segreteria Telefonica"
                           readonly
                           dense
                           v-model="VMOptions.pbxNumber.value"
                        >
                        </v-text-field>
                        <v-text-field
                           outlined
                           dense
                           label="Insegna Locale"
                           v-model="VMOptions.pbxBrand.value"
                        >
                        </v-text-field>
                        <v-textarea
                           outlined
                           auto-grow
                           rows="2"
                           dense
                           label="Messaggio Orari"
                           v-model="VMOptions.pbxOpeningHourMessage.value"
                        > 
                        </v-textarea>
                        <v-textarea
                           outlined
                           auto-grow
                           rows="2"
                           dense
                           label="Messaggio Menu"
                           v-model="VMOptions.pbxMenuMessage.value"
                        > 
                        </v-textarea>
                        <v-text-field
                           outlined
                           dense
                           label="Richiama dopo Le"
                           v-model="VMOptions.pbxRecallTime.value"
                        > 
                        </v-text-field>  
                        <v-divider></v-divider> 
                        <v-text-field
                           outlined
                           dense
                           label="Traferisci Chiamata al Numero"
                           v-model="VMOptions.pbxForwardNumber.value"
                        > 
                        </v-text-field>   
                        <v-text-field
                           outlined
                           dense
                           label="dalle"
                           v-model="VMOptions.pbxForwardFrom.value"
                        > 
                        </v-text-field>   
                        <v-text-field
                           outlined
                           dense
                           label="alle"
                           v-model="VMOptions.pbxForwardTo.value"
                        >
                        </v-text-field> 
                        <v-text-field
                           outlined
                           dense
                           label="Numero per Prenotazioni Telefoniche"
                           v-model="VMOptions.phoneBookingNumber.value"
                        >
                        </v-text-field>
                        -->
                     </v-col>
                     <v-col cols="8">
                        <v-treeview
                           v-model="tree"
                           :open="initiallyOpen"
                           :items="items"
                           activatable
                           item-key="name"
                           open-on-click
                           
                           ref="mytreeview"
                        >
                           <template v-slot:prepend="{ item, open }">
                              <v-icon v-if="!item.file">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                              </v-icon>
                              <v-icon v-else>
                              {{ files[item.file] }}
                              </v-icon>
                           </template>
                           <template v-slot:label="{ item }">
                              <span class="info--text" v-if="item.msg" v-html="' '+item.msg"></span> 
                              <template v-else>
                              {{item.name}}  
                              </template>
                              <span class="red--text mr-2" v-if="item.p_msg" v-html="' '+item.p_msg"></span>
                           </template>      
                        </v-treeview>        
                     </v-col>
                  </v-row>  
               </v-card>
            </div>
        </v-card>
      </v-form>
    <v-dialog v-model="dialog_instruction" max-width="900">
        <v-card class="pb-3">
            <v-card-title class="text-h5 mb-3"
            >
              Istruzioni
            <v-spacer></v-spacer>
            <div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=false">
                    <v-icon color="info">mdi-close-circle</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>            </div>                
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 text-justify">
                <v-col md="6" cols="12">
                  <p>
                     Il <span class="red--text font-weight-black">Numero Segreteria Telefonica</span> è il numero al quale dovete deviare il numero del vostro locale per utilizzare la segreteria telefonica.
                  </p>
                  <p>Il chiamante non si accorge che la chiamata è stata deviata, ne tantomeno su un numero USA, questo non comporta alcun costo ne per il chiamante, e di norma, nemmeno per Voi, visto che  tutti i piani tariffari consentono chiamate illimitate verso numeri USA</p>
                  <p>Viene utilizzato un numero USA in quanto questo non presenta formalità, ha costi inferiori e consente l'attribuzione in tempo reale del numero e quindi del servizio</p>
                  <p>
                     Su richiesta è possibile attribuire un numero telefonico italiano con prefisso 0372 oppure con il vostro stesso prefisso
                  </p>
                  <p>
                     Tali opzioni comportano dei costi di attivazione e disattivazione e un maggior canone mensile. Se interessati a tali opzioni, contattateci
                  </p>
                </v-col>
                <v-col md="6" cols="12">
                  <p>
                     il <span class="red--text font-weight-black">Numero Telefonico al quale deviare la chiamata</span> è il numero al quale deviare la chiamata, qualora la chiamata sia ricevuta nell'intervallo di tempo indicato nelle relative caselle.
                  </p>
                  <p>
                     Lo stesso risultato si può ottenere disabilitando il trasferimento dal vostro numero alla segreteria telefonica:
                  </p>
                  <p>Il vantaggio di utilizzare questa opzione è che non dovete più ricordare di abilitare/disabilitare ogni giorno il trasferimento dal vostro numero alla segreteria</p>
                  <p>Lo svantaggio consiste nel fatto che il trasferimento di chiamata ha dei costi: 2 €cent al minuto su linea fissa e da 40 fino a 60 €cent su linea mobile, in funzione dell'operatore</p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_confirm" persistent max-width="700">
        <v-card class="mb-3">
            <v-card-title class="text-h5 mb-3"
            >
              {{!pbxEnabled?'Conferma Disattivazione Segreteria Telefonica':'Conferma Attivazione Segreteria Telefonica'}}
               <v-spacer></v-spacer>
               <div>
               <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                     <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.stop="VMChangeStatus()">
                     <v-icon color="error">mdi-content-save</v-icon>
                     </v-btn>
                  </template>
                  <span>Conferma</span>
               </v-tooltip>                
               <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                     <v-btn v-bind="attrs" v-on="on" icon  fab small class="neu-glow mr-2" :loading="loading" @click="pbxEnabled=!pbxEnabled;dialog_confirm=false">
                     <v-icon color="info">mdi-close-circle</v-icon>
                     </v-btn>
                  </template>
                  <span>Annulla</span>
               </v-tooltip>              
               </div>                
            </v-card-title>
            <v-row class="mx-5" v-if="pbxEnabled">
                <v-col cols="12">
                  <p>
                     L'attivazione della segreteria telefonica prevede l'attribuzione di un numero telefonico di New York e <span class="red--text font-weight-black">l'addebito automatico di un canone mensile</span> e di tutti i servizi a consumo ad esso collegati, come da report che troverete allegato alla fattura.
                  </p>
                  <p>
                     Il servizio si rinnova tacitamente alla scadenza per ulteriori 30/31 giorni. E' possibile recedere in ogni momento dal servizio: verrà addebitato solamente l'importo del canone mensile in corso.
                  </p>
                  <p>
                     Si precisa che eventuali numeri attribuiti ed in seguito disattivati NON vengono da noi riutilizzati, ma detti numeri, in quanto pubblici, potrebbero ricevere chiamate casuali o di marketing anche da operatori statunitensi.
                  </p>
                </v-col>
            </v-row>
            <v-row class="mx-5" v-else>
                <v-col cols="12">
                    <p>
                        La disattivazione della segreteria telefonica è immediata, sebbene il canone venga addebitato fino allo scadere dei periodo in corso.
                    </p>
                    <p>
                      Si consiglia di attendere il termine del periodo.
                    </p>
                </v-col>
            </v-row>            
        </v-card>
    </v-dialog>        
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_editOption:false,
      dialog_confirm:false,
      dialog_instruction:false,
      loading_refresh:false,
      pbxEnabled:false,
      snackbar_message:null,
      snackbar:false,
      snackbar_color:null,

      initiallyOpen: ['Segreteria Telefonica','Scelta Automatica Lingua in funzione del numero chiamante','Italiano','Pizzeria','Scelta:'],
      /*
      brand:'Pizzeria o\' Vesuvio',
      openingHours:'Siamo aperti tutti i giorni dalle 11:45 alle 14:30 e dalle 18.45 alle 23:30 - La cucina chiude alle 22:30 - Lunedì Chiuso',
      menu:'Facciamo Tutte le Pizze ma solo la Pizza',
      recall:'17:30',
      */
      Demo:[
         {"pbxNumber":"001 929 999 1240"},
         {"pbxBrand":"Pizzeria o' Vesuvio"},
         {"pbxOpeningHourMessage":"Siamo aperti tutti i giorni dalle 11:45 alle 14:30 e dalle 18.45 alle 23:30 - La cucina chiude alle 22:30 - Lunedì Chiuso"},
         {"pbxMenuMessage":"Facciamo Tutte le Pizze ma solo la Pizza'"},
         {"pbxRecallTime":"17:30"},
         {"pbxForwardNumber":"02 22 22 22 1"},
         {"pbxForwardFrom":"11:00"},
         {"pbxForwardTo":"17:00"},
         {"phoneBookingNumber":"011 33 33 33"}
      ],
      expanded: false,
      VMOptions:null,
      VMOptions_hash:null,
      files: {
        face: 'mdi-face-agent',
        speak: 'mdi-volume-high',
        select: 'mdi-sitemap',
        language: 'mdi-translate',
        book: 'mdi-pencil',
        wa: 'mdi-whatsapp',
        end: 'mdi-phone-hangup',
        chat: 'mdi-account-voice',
        transfer:'mdi-transfer-right',
        previous:'mdi-skip-previous',
        previous2:'mdi-skip-backward',
        info:'mdi-information',
        time:'mdi-store-clock',
        
      },
      tree: [],
      items:  [
                  {
                     "name": "Segreteria Telefonica",
                     "file": "face",
                     "children": [
                        {
                           "name": "Scelta Automatica Lingua in funzione del numero chiamante",
                           "file": "select",
                           "children": [
                              {
                                 "name": "Italiano",
                                 "file": "language",
                                 "children": [
                                    {
                                       "name": "Pizzeria",
                                       "p_msg": "Pizzeria Bella Napoli",
                                       "msg": "\"Buongiorno/Buonasera\", sono l'assistente Virtuale di ",
                                       "file": "speak",
                                       "children": [
                                          {
                                             "name": "Scelta:",
                                             "file": "select",
                                             "children": [
                                                {
                                                   "name": "",
                                                   "msg": "Premi 1, per Prenotare.",
                                                   "file": "book",
                                                   "children": [
                                                      {
                                                         "name": "",
                                                         "msg": "Premi 1, Per prenotare col sistema rapido di prenotazione attraverso whatsApp: Riceverai un messaggio per prenotare rapidamente sulla nostra piattaforma",
                                                         "file": "wa",
                                                         "children": [
                                                            {
                                                               "name": "",
                                                               "msg": "Messaggio Inviato",
                                                               "file": "speak",
                                                               "children": [
                                                                  {
                                                                     "name": "",
                                                                     "msg": "Grazie per aver chiamato",
                                                                     "p_msg": "Pizzeria Bella Napoli",
                                                                     "file": "speak",
                                                                     "children": [
                                                                        {
                                                                           "name": "Chiamata Terminata",
                                                                           "file": "end"
                                                                        }
                                                                     ]
                                                                  }
                                                               ]
                                                            }
                                                         ]
                                                      },
                                                      {
                                                         "name": "",
                                                         "msg": "Premi 2, Per parlare con un Operatore.",
                                                         "file": "chat",
                                                         "children": [
                                                            {
                                                               "name": "Trasferimento Chiamata: se abilitato e dopo le",
                                                               "p_msg": "17:30",
                                                               "file": "transfer",
                                                               "children": [
                                                                  {
                                                                     "name": "",
                                                                     "msg": "Grazie per aver chiamato",
                                                                     "p_msg": "Pizzeria Bella Napoli",
                                                                     "file": "speak",
                                                                     "children": [
                                                                        {
                                                                           "name": "Chiamata Terminata",
                                                                           "file": "end"
                                                                        }
                                                                     ]
                                                                  }
                                                               ]
                                                            }
                                                         ]
                                                      },
                                                      {
                                                         "name": "",
                                                         "msg": "Premi 8, Per tornare al menù precedente.",
                                                         "file": "previous"
                                                      },
                                                      {
                                                         "name": "",
                                                         "msg": "Premi 9, Per terminare.",
                                                         "file": "previous2"
                                                      }
                                                   ]
                                                },
                                                {
                                                   "name": "",
                                                   "msg": "Premi 2, per Informazioni su orari di apertura, Menù ed Informazioni Generali.",
                                                   "file": "info",
                                                   "children": [
                                                      {
                                                         "name": "Orari",
                                                         "file": "time",
                                                         "children": [
                                                            {
                                                               "name": "",
                                                               "p_msg": "Siamo aperti a cena dalle 19:30 alle 22:30, tutte le sere, tranne il Mercoledì. Accettiamo animali a 4 zampe",
                                                               "file": "speak",
                                                               "children": [
                                                                  {
                                                                     "name": "Scelta",
                                                                     "file": "select",
                                                                     "children": [
                                                                        {
                                                                           "name": "",
                                                                           "msg": "Prem 1 per Prenotare",
                                                                           "file": "speak",
                                                                           "children": [
                                                                              {
                                                                                 "name": "Trasferito all'opzione 1",
                                                                                 "msg": "",
                                                                                 "file": "transfer"
                                                                              }
                                                                           ]
                                                                        },
                                                                        {
                                                                           "name": "",
                                                                           "msg": "Premi 2 per Ricevere un messaggio WhatsApp con il link al nostro Menù",
                                                                           "file": "speak",
                                                                           "children": [
                                                                              {
                                                                                 "name": "",
                                                                                 "msg": "Messaggio WhatsApp Inviato",
                                                                                 "file": "speak",
                                                                                 "children": [
                                                                                    {
                                                                                       "name": "",
                                                                                       "msg": "Grazie per aver chiamato",
                                                                                       "p_msg": "Pizzeria Bella Napoli",
                                                                                       "file": "speak"
                                                                                    }
                                                                                 ]
                                                                              }
                                                                           ]
                                                                        }
                                                                     ]
                                                                  }
                                                               ]
                                                            }
                                                         ]
                                                      },
                                                      {
                                                         "name": "Menu",
                                                         "file": "menu",
                                                         "children": [
                                                            {
                                                               "name": "",
                                                               "p_msg": "Offriamo tutte le tipologie di Pizza... ma solo la Pizza, e desserts",
                                                               "file": "speak",
                                                               "children": [
                                                                  {
                                                                     "name": "Scelta",
                                                                     "file": "select",
                                                                     "children": [
                                                                        {
                                                                           "name": "",
                                                                           "msg": "Prem 1 per Prenotare",
                                                                           "file": "speak",
                                                                           "children": [
                                                                              {
                                                                                 "name": "Trasferito all'opzione 1",
                                                                                 "msg": "",
                                                                                 "file": "speak"
                                                                              }
                                                                           ]
                                                                        },
                                                                        {
                                                                           "name": "",
                                                                           "msg": "Prem 2 per Ricevere un messaggio WhatsApp con il link al nostro Menù",
                                                                           "file": "speak",
                                                                           "children": [
                                                                              {
                                                                                 "name": "",
                                                                                 "msg": "Messaggio WhatsApp Inviato",
                                                                                 "file": "speak",
                                                                                 "children": [
                                                                                    {
                                                                                       "name": "",
                                                                                       "msg": "Grazie per aver chiamato",
                                                                                       "p_msg": "Pizzeria Bella Napoli",
                                                                                       "file": "speak"
                                                                                    }
                                                                                 ]
                                                                              }
                                                                           ]
                                                                        }
                                                                     ]
                                                                  }
                                                               ]
                                                            }
                                                         ]
                                                      }
                                                   ]
                                                },
                                                {
                                                   "name": "",
                                                   "msg": "Premi 3, per essere ricontattato dopo le",
                                                   "p_msg": "17:30",
                                                   "file": "chat",
                                                   "children": [
                                                      {
                                                         "name": "",
                                                         "msg": "Abbiamo Segnalato la tua richiesta. Sarai ricontattato dallo staff dopo le",
                                                         "p_msg": "17:30",
                                                         "file": "speak",
                                                         "children": [
                                                            {
                                                               "name": "",
                                                               "msg": "Grazie per aver chiamato ",
                                                               "p_msg": "Pizzeria Bella Napoli",
                                                               "file": "speak",
                                                               "children": [
                                                                  {
                                                                     "name": "Chiamata Terminata",
                                                                     "file": "end"
                                                                  }
                                                               ]
                                                            }
                                                         ]
                                                      }
                                                   ]
                                                }
                                             ]
                                          }
                                       ]
                                    }
                                 ]
                              },
                              {
                                 "name": "Inglese",
                                 "file": "language"
                              }
                           ]
                        }
                     ]
                  }
              ]    
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.settings&&this.settings.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
   /*
   VMOptions: 
   {  handler: function (newName,oldName)
      {
         console.log(618,newName,oldName)
      },
      deep:true,
   },   
   'VMOptions.pbxBrand': function(newValue)
   {
      console.log(696,newValue);
      this.items[0].children[0].children[0].children[0].p_msg =newValue;
      this.items[0].children[0].children[0].children[0].children[0].children[0].children[0].children[0].children[0].p_msg =newValue;
      this.items[0].children[0].children[0].children[0].children[0].children[0].children[1].children[0].children[0].p_msg =newValue;
      this.items[0].children[0].children[0].children[0].children[0].children[2].children[0].children[0].p_msg =newValue;
      this.items[0].children[0].children[0].children[0].children[0].children[1].children[0].children[0].children[0].children[1].children[0].children[0].p_msg=newValue;
      this.items[0].children[0].children[0].children[0].children[0].children[1].children[1].children[0].children[0].children[1].children[0].children[0].p_msg=newValue;
   },
   'VMOptions.pbxOpeningHourMessage':function(newValue)
   {
      console.log(706,newValue);
      this.items[0].children[0].children[0].children[0].children[0].children[1].children[0].children[0].p_msg =newValue
      //this.items[0].children[0].children[0].children[0].children[0].children[1].children[1].children[0].p_msg=newValue
   },
   'VMOptions.pbxRecallTime':function(newValue)
   {
      console.log(712,newValue);
      this.items[0].children[0].children[0].children[0].children[0].children[2].p_msg =newValue
      this.items[0].children[0].children[0].children[0].children[0].children[2].children[0].p_msg =newValue
      this.items[0].children[0].children[0].children[0].children[0].children[0].children[1].children[0].p_msg=newValue
   },
   'VMOptions.pbxMenuMessage':function(newValue)
   {
      console.log(719,newValue);
      this.items[0].children[0].children[0].children[0].children[0].children[1].children[1].children[0].p_msg =newValue
   },*/
  },
  methods:
  {
   voiceMailChangeStatus()
   {
      console.log(759,this.pbxEnabled)
      this.dialog_confirm=true;
   },
   async VMChangeStatus()
   {
      var action='saveItem';
      var table=this.pbxEnabled?'VoiceMailEnable':'VoiceMailDisable';
      var pload={"action":table};      
      let payload={"action":action,"table":table,"payload":pload};
      console.log(652,payload)
      var w = await this.updateDB(payload);
      console.log(751,w,w.payloads.pbxNumber)
      if(w.errorid=='0')
      {
         //console.log(747)
         if(this.pbxEnabled)
         {
            console.log(750)
            this.VMOptions.find(o=>o.optionId=='pbxNumber').value=w.payloads.pbxNumber;
            this.VMOptions.find(o=>o.optionId=='pbxEnabledOn').value=w.payloads.pbxEnabledOn;
            this.dialog_confirm=false;
         } 
         else
         {
            console.log(757)
            this.VMOptions.find(o=>o.optionId=='pbxNumber').value=w.payloads.pbxNumber;
            this.VMOptions.find(o=>o.optionId=='pbxEnabledOn').value=w.payloads.pbxEnabledOn;
            this.dialog_confirm=false;
         }
      }
      else
      {
         console.log(762)
      }
   },
   refreshItem(field,newValue)
   {
      switch(field)
      {
         case 'pbxBrand':
            this.items[0].children[0].children[0].children[0].p_msg =newValue;
            this.items[0].children[0].children[0].children[0].children[0].children[0].children[0].children[0].children[0].p_msg =newValue;
            this.items[0].children[0].children[0].children[0].children[0].children[0].children[1].children[0].children[0].p_msg =newValue;
            this.items[0].children[0].children[0].children[0].children[0].children[2].children[0].children[0].p_msg =newValue;
            this.items[0].children[0].children[0].children[0].children[0].children[1].children[0].children[0].children[0].children[1].children[0].children[0].p_msg=newValue;
            this.items[0].children[0].children[0].children[0].children[0].children[1].children[1].children[0].children[0].children[1].children[0].children[0].p_msg=newValue;
         break;
         case 'pbxOpeningHourMessage':
            this.items[0].children[0].children[0].children[0].children[0].children[1].children[0].children[0].p_msg =newValue
         break;
         case 'pbxMenuMessage':
            this.items[0].children[0].children[0].children[0].children[0].children[1].children[1].children[0].p_msg =newValue
         break;
         case 'pbxRecallTime':
            this.items[0].children[0].children[0].children[0].children[0].children[2].p_msg =newValue
            this.items[0].children[0].children[0].children[0].children[0].children[2].children[0].p_msg =newValue
            this.items[0].children[0].children[0].children[0].children[0].children[0].children[1].children[0].p_msg=newValue
         break
      }
   },
   save: _.debounce(function (event) {
      this.refreshItem(event.target.name,event.target.value)
      console.log(632,event.target.name,event.target.value)
      console.log(633,this.VMOptions)
      console.log(634,this.VMOptions[event.target.name])

      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      var pload={"optionId":event.target.name,"value":value};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(641,payload)
      this.updateDB(payload)
    }, 1000),
    save2(value, field) {
      console.log(645,value, field);
      var pload={"optionId":field,"value":value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(652,payload)
      this.updateDB(payload)
    },    
   enableVoiceMail()
   {
      console.log(555,'VM enabled')

   },
    toggleTreeview() {
      this.expanded = !this.expanded;
      if (!this.expanded)
      {
        this.$refs.mytreeview.updateAll(this.initiallyOpen);
      }
      else
      {
        this.$refs.mytreeview.updateAll(this.expanded);
      }
    },    
    itemClass(item)
    {
      var clr=!item.bookable?'grey lighten-3':'';
      return clr;
    },    
    editOption(f)
    {
      this.editedOption=f;
      console.log(214,f)
      this.dialog_editOption=true;
    },
    /*
    async saveOption(a)
    {
        console.log(144,this.editedOption);
        this.loading_update=true;
        console.log(255,this.form);
        var action='';
        if(a=='delete')
        {
          action='unsetOption'
          f.active=0;
        }
        else
        {
          action='saveOption';
        }
        let payload={"action":action,"payload":JSON.stringify(this.editedOption)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editOption=false;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    },
    */
    async saveItems()
    {
        this.loading_update=true;
        console.log(255,this.form);
        var license=this.items.filter(l=>l.active===true&&l.bookable===true).map(l=>l.value).reduce((a,b)=>a+b);
        let payload={"action":"saveItem","table":"License","payload":license};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
             this.getData();
        }   
    },    
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            //try
            {
                const payload=JSON.stringify({"date": this.date,"action":"VoiceMail_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                  case '0':
                        sessionStorage.setItem('jwt', res.data.jwt);
                        this.VMOptions=res.data.payloads.VMOptions.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); return o});
                        this.VMOptions_hash=JSON.stringify(this.VMOptions);
                        this.pbxEnabled=this.VMOptions.find(o=>o.optionId=='pbxEnabled').value;
                      console.log(315,this.VMOptions,this.VMOptions_hash,this.pbxEnabled)
                      console.log(843,this.pbxEnabled)
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            } 
            /*catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }*/
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>